import React from 'react';

const NoResult = () => {
    return (
        <div className="no-result-container">
            
            <img className="oops-image" alt="noresult-img" src="https://i.pinimg.com/originals/3e/80/5a/3e805ae9d6f701cf0758868b9cbed09f.jpg"/>
            <h2>Oops, no users found. please try again.</h2>
        </div>
    )
}

export default NoResult;